import { generateUUID } from './utils';

/**
 * Session manager for tracking user sessions
 * Handles session ID generation and customer identification
 */
export class SessionManager {
  private sessionId: string;
  private customerId: string | null = null;
  private startTime: number;

  constructor() {
    this.sessionId = generateUUID();
    this.startTime = Date.now();
  }

  getSessionId(): string {
    return this.sessionId;
  }

  getDuration(): number {
    return Math.floor((Date.now() - this.startTime) / 1000);
  }

  setCustomerId(id: string): void {
    this.customerId = id;
  }

  getCustomerId(): string | null {
    return this.customerId;
  }

  isIdentified(): boolean {
    return this.customerId !== null;
  }

  reset(): void {
    this.sessionId = generateUUID();
    this.customerId = null;
    this.startTime = Date.now();
  }

  clearIdentification(): void {
    this.customerId = null;
  }
}
